import { render, staticRenderFns } from "./UsersFilters.vue?vue&type=template&id=1241397e&"
import script from "./UsersFilters.vue?vue&type=script&lang=ts&"
export * from "./UsersFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports